<template>
  <hr-multi-select
    ref="group"
    :model-value="modelValue"
    option-value="id"
    :label="group.label"
    input-debounce="0"
    :options="availableItemsFiltered"
    emit-object

    use-input

    hide-bottom-space

    @input-value="onInputValue"
    @update:model-value="onInputItem"
    @new-value="onAddItem"
    @filter="onFilterItems"
    @keydown="onBackspace"
  />
</template>
<script>
import { chain, filter, find, isNil, trim } from 'lodash';
import { mapState } from 'pinia';
import { uid } from 'quasar';
import { HrMultiSelect } from 'src/design-system';
import { programBehaviourData } from 'src/store/programBehaviourData';

export default {
  name: 'BehaviourGroupSelect',

  components: {
    HrMultiSelect,
  },

  props: {
    program: {
      type: Object,
      required: true,
    },

    group: {
      type: Object,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    modelValue: {
      type: Array,
      required: true,
    },

  },

  emits: ['update:modelValue'],

  data() {
    return {
      isSaving: false,

      groups: [],

      availableItemsFiltered: [],
      addedItems: [],

      inputItem: null,
      inputValue: '',
      isBackspaceDeleted: false,
    };
  },

  computed: {
    ...mapState(programBehaviourData, ['programBehaviourGroups', 'programBehaviourGroupItems']),

    availableItems() {
      return chain(this.group)
        .get('items')
        .concat(this.addedItems)
        .value();
    }, // availableItems
  },

  watch: {
    'groups.items': {
      immediate: true,
      deep: true,
      handler(newGroupItems) {
        this.availableItemsFiltered = newGroupItems;
      },
    },

    inputValue(newVal, oldVal) {
      if (!newVal && oldVal && !this.isBackspaceDeleted) {
        this.onAddItem(oldVal, this.doneUniqueMode);
      }

      this.isBackspaceDeleted = false;
    },
  },

  created() {
    this.addedValues = [];
  }, // created()

  methods: {

    doneUniqueMode(val) {
      if (isNil(val)) {
        return;
      }

      this.$refs.group.add(val, true);
    },

    onBackspace(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.isBackspaceDeleted = true;
        return;
      }

      this.isBackspaceDelete = false;
    },

    onInputValue(value) {
      this.inputValue = value;
    },

    onInputItem(selectedItems) {
      this.$emit('update:modelValue', selectedItems);

      this.$refs.group.hidePopup();
    }, // onInputItem()

    onAddItem(val, done) {
      const trimmedVal = trim(val);
      const trimmedValLower = trimmedVal.toLowerCase();
      if (trimmedVal) {
        const existingValue = find(
          this.availableItems,
          (item) => chain(item).get('label').trim().toLower()
            .value() === trimmedValLower,
        );
        if (existingValue) {
          this.$refs.group.hidePopup();
          done(existingValue, 'add-unique');
          return;
        }

        const newItem = {
          id: uid(),
          label: trimmedVal,
          isDeleted: false,
          editStatus: 'create',
        };
        this.$refs.group.hidePopup();
        done(newItem, 'add-unique');
        this.availableItems.push(newItem);
      }
    }, // onAddItem()

    onFilterItems(val, update) {
      update(() => {
        if (!val) {
          this.availableItemsFiltered = this.availableItems;
        } else {
          const trimmedValLower = val.toLowerCase();
          this.availableItemsFiltered = filter(
            this.availableItems,
            (v) => chain(v).get('label').toLower().value()
              .indexOf(trimmedValLower) > -1,
          );
        }
      });
    },

  },
};
</script>
